export default {
  name: "AppInput",

  inheritAttrs: false,

  props: {
    size: {
      type: String,
      default: ""
    },
    theme: {
      type: String,
      default: "first"
    },
    icon: String,
    disabled: Boolean,
    readonly: Boolean,
    invalid: Boolean
  },

  computed: {
    classes() {
      return {
        [`app-input_theme_${this.theme}`]: true,
        [`app-input_size_${this.size}`]: !!this.size,
        "is-disabled": this.disabled,
        "is-invalid": this.invalid
      };
    }
  }
};
